import { Component } from '../../../libs/gin-tonic/helpers/compiler';
import { Tabs } from './index';

@Component({ className: 'js-tabs', observe: true })
export class TabsComponent {
	constructor(private element: HTMLElement) {
		new Tabs(element);
	}
}
